import { useLinkLogic } from '@/app/navigation/stack-links';
import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { EntityForm } from '@/components/forms/EntityForm';
import { createLabelDetailLayout } from '@/features/labels/labels.schemas';
import { useCreateLabel } from '@/features/labels/labels.hooks';
import { useEntityForm } from '@/hooks/useEntityForm';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

export const LabelCreatePanel = ({
  params,
  path,
  basePath,
  ...panelProps
}: RoutedPanelProps) => {
  const navigate = useNavigate();
  const makeLink = useLinkLogic();

  const entityForm = useEntityForm({
    layout: createLabelDetailLayout,
    isLoading: false,
    data: undefined,
    defaultValues: {
      name: '',
      tickets: true,
      lists: true,
    },
  });

  const createLabelMutation = useCreateLabel();

  return (
    <Panel {...panelProps}>
      <EntityForm
        {...entityForm}
        onSubmit={entityForm.form.handleSubmit(
          async (formValues) => {
            try {
              const result = await createLabelMutation.mutateAsync(formValues);

              // Navigate back or to the new label
              const to = makeLink(
                path.replace(/new$/, result.recnum.toString()),
              );
              navigate({ to });
            } catch (error) {
              toast.error('Could not create label', {
                description:
                  error instanceof Error ? error.message : 'Unknown error',
              });
            }
          },
          (errors) => {
            console.log('invalid', { errors });
          },
        )}
      />
    </Panel>
  );
};
